import React from 'react';
import { LOGO_SHEET, SHEET_W, type Logo } from '../../data/logos';
type LogoMarkProps = {
  logo: Logo;
  /** Bounding box, in stage cqh units. */
  maxW: number;
  maxH: number;
  /** Optional target area (cqh²) for optical size matching across logos. */
  area?: number;
  /** Light monochrome treatment for dark backgrounds. */
  mono?: boolean;
  className?: string;
};

/** Renders one logo cropped from the approved sheet, preserving proportions. */
export function LogoMark({
  logo,
  maxW,
  maxH,
  area,
  mono,
  className
}: LogoMarkProps) {
  const fit = Math.min(maxW / logo.w, maxH / logo.h);
  const s = area ? Math.min(fit, Math.sqrt(area / (logo.w * logo.h))) : fit;
  return <div role="img" aria-label={logo.name} className={className} style={{
    width: `${logo.w * s}cqh`,
    height: `${logo.h * s}cqh`,
    backgroundImage: `url("${LOGO_SHEET}")`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: `${SHEET_W * s}cqh auto`,
    backgroundPosition: `${-logo.x * s}cqh ${-logo.y * s}cqh`,
    filter: mono ? 'grayscale(1) invert(1) brightness(1.1)' : undefined,
    mixBlendMode: mono ? 'screen' : undefined,
    opacity: mono ? 0.8 : undefined
  }} data-id="element-16" data-mp="20dr4gt8iu1m0" />;
}